// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { equipmentId } from './Equipment';
import { harvestScaleId } from './HarvestScale';
import { z } from 'zod';
export const equipmentScale = z.object({
    equipment_id: equipmentId,
    scale_id: harvestScaleId,
});
export const equipmentScaleInitializer = z.object({
    equipment_id: equipmentId,
    scale_id: harvestScaleId,
});
export const equipmentScaleMutator = z.object({
    equipment_id: equipmentId.optional(),
    scale_id: harvestScaleId.optional(),
});
//# sourceMappingURL=EquipmentScale.js.map